import React, { useEffect, useState } from 'react'
import styled from 'styled-components'

import Textarea from 'components/Textarea'
import { color } from 'styles/colors'
import { screenSize } from 'styles/shared'
import { parseIntoDescriptionsAndDetails } from 'helpers/alerts'

export interface CallToAction {
  description: string
  details: Array<string>
}

const INSTRUCTION_PLACEHOLDER = `description
  - detail
  - detail
  description
  - detail
  - detail
`
const generateUniqueId = () => `id_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`

type props = {
  label: string
  onChange: (event) => void
  errorMessage?: string
  isRequired?: boolean
  value: string,
  className?: string
}

const TextAreaWithPreview = ({ className = '', label, onChange, errorMessage, isRequired, value } : props) => {
  const [parsedData, setParsedData] = useState<CallToAction[]>([])

  useEffect(() => {
    if (value.length > 0) setParsedData(parseIntoDescriptionsAndDetails(value))
  }, [value])

  return (
    <S.Container className={className}>
      <S.Textarea
        {...{ onChange, errorMessage, isRequired, value }}
        rows={7}
        label={label}
        placeholder={INSTRUCTION_PLACEHOLDER}
      />

      <S.PreviewContainer>
        <S.PreviewLabel>Preview</S.PreviewLabel>
        <S.Preview>
          {parsedData?.map(item => (
            <S.Description key={generateUniqueId()}>
              <p>{item.description}</p>
              <ul>
                {item.details?.map(detail => <S.Detail key={generateUniqueId()}>{detail}</S.Detail>)}
              </ul>
            </S.Description>
          ))}
        </S.Preview>
      </S.PreviewContainer>
    </S.Container>
  )
}

export default TextAreaWithPreview

const S = {
  Container: styled.div`
    display: grid;
    width: 100%;
    grid-template-columns: 50% 48%;
    gap: 20px;
    margin-bottom: 10px;
    padding-top: 25px;

    @media ${screenSize.small} {
      display: block;
    }
  `,
  Textarea: styled(Textarea)`
    height: 200px;
    padding-top: 5px;
     > textarea {
      resize: none;
      line-height: 1.6;
    }
  `,
  PreviewContainer: styled.div`
    padding-top: 5px;
  `,
  PreviewLabel: styled.label`
    @media ${screenSize.small} {
      display: none;
    }
  `,
  Preview: styled.div` 
    display: inline-block;
    height: 200px;
    width: 100%;
    background: ${color('alertFormPreviewBackground')};
    border: 0.5px solid ${color('border')};
    border-left: none;
    box-shadow: inset 0px 0px 2px 0px ${color('border')};
    overflow: scroll;
    word-wrap: break-word;

    @media ${screenSize.small} {
      display: none;
    }
  `,
  Description: styled.div`
    > p, ul{
      margin: 0;
      padding: 5px 0px 0px 5px;
    }  
  `,
  Detail: styled.li`
    margin-left: 16px;
  `
}
